import {
  Component,
  input,
  Output,
  EventEmitter,
  inject,
  OnInit,
  Input,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { CommonModule } from '@angular/common';
import { EnumService } from '@app/shared/components/api/services/enum.service';
import { Router } from '@angular/router';
import { AnexoFicheiroService } from '@app/shared/components/api/services/anexo-ficheiro.service';
import { TrimTextPipe } from '@app/shared/pipes/trim-text.pipe';
import { TruncateTextComponent } from '@app/shared/components/truncate-text/truncate-text.component';
import { SocialIconPipe } from '@app/shared/pipes/social-icon.pipe';
import { CampanhaService } from '@app/shared/components/api/services/campanha.service';
import { DialogModule } from 'primeng/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Pagination } from '@app/shared/components/api/models/pagination.model';
import { PaginatorControlComponent } from '@app/shared/components/paginator-control/paginator-control.component';
import { MessageService } from 'primeng/api';
import { TableModule } from 'primeng/table';
import { DataVoidComponent } from '@app/shared/components/data-void/data-void.component';
import { TagModule } from 'primeng/tag';
import { ApoioService } from '@app/shared/components/api/services/apoio.service';
import { ConfiguracoesService } from '@app/shared/components/api/services/configuracoes.service';
import { MoneyPipe } from '@app/shared/pipes/money.pipe';

@Component({
  selector: 'app-admin-detalhe-campanha',
  imports: [
    CommonModule,
    FormsModule,
    CheckboxModule,
    TrimTextPipe,
    TruncateTextComponent,
    SocialIconPipe,
    DialogModule,
    PaginatorControlComponent,
    TableModule,
    CommonModule,
    DataVoidComponent,
    TagModule,
    MoneyPipe,
  ],
  providers: [
    EnumService,
    AnexoFicheiroService,
    CampanhaService,
    ApoioService,
    ConfiguracoesService,
  ],
  standalone: true,
  templateUrl: './admin-detalhe-campanha.component.html',
  styleUrl: './admin-detalhe-campanha.component.scss',
})
export class AdminDetalheCampanhaComponent implements OnInit {
  campanha = input<any>();
  @Input() showExtend: boolean = true;
  private readonly enumService = inject(EnumService);
  private readonly configuracoesService = inject(ConfiguracoesService);
  private readonly anexoFicheiroService = inject(AnexoFicheiroService);
  private readonly campanhaService = inject(CampanhaService);
  private readonly route = inject(Router);
  private readonly messageService = inject(MessageService);
  private readonly apoioService = inject(ApoioService);
  pagamentos: any;
  pagination: Pagination<any> = new Pagination<any>();
  campanhaData: any;
  tipoFinanciamentoCampanha: any;
  ComissaoCampanha: any;
  taxaServico: any;
  tipoFinanciamento: any[] = [];
  @Output() onCloseModal = new EventEmitter<boolean>();
  selectedTypeFinancy: number | null = null;
  imgPreview?: string;
  docPreview?: SafeResourceUrl;
  vidPreview?: string;
  linkVideo?: string;
  embedVideoUrl?: any;
  docRawUrl?: string;
  imgRawUrl?: string;
  imgInfo?: { nome: string; tamanho: string; tipo: string };
  docInfo?: { nome: string; tamanho: string; tipo: string };
  VidInfo?: { nome: string; tamanho: string; tipo: string };

  constructor(private readonly sanitizer: DomSanitizer) {}

  ngOnInit() {
    this.getAllTipoFinanciamento();
    this.getCampanhaByID(this.campanha().id);
    this.getPagamentosByCampanhaID();
  }

  formatExternalUrl(url?: string): string {
    if (!url) return '';
    const trimmed = url.trim();
    if (!trimmed.startsWith('http://') && !trimmed.startsWith('https://')) {
      return `https://${trimmed}`;
    }
    return trimmed;
  }

  getEmbedUrl(url: string): string {
    if (!url) return '';
    const trimmed = this.formatExternalUrl(url);

    // YouTube watch?v=
    if (trimmed.includes('youtube.com/watch?v=')) {
      const id = trimmed.split('v=')[1]?.split('&')[0];
      return `https://www.youtube.com/embed/${id}?autoplay=1`;
    }

    // YouTube short youtu.be/
    if (trimmed.includes('youtu.be/')) {
      const id = trimmed.split('youtu.be/')[1]?.split('?')[0];
      return `https://www.youtube.com/embed/${id}?autoplay=1`;
    }

    // YouTube shorts
    if (trimmed.includes('youtube.com/shorts/')) {
      const id = trimmed.split('youtube.com/shorts/')[1]?.split('?')[0];
      return `https://www.youtube.com/embed/${id}?autoplay=1`;
    }

    // YouTube embed already
    if (trimmed.includes('youtube.com/embed/')) {
      return trimmed;
    }

    // Vimeo
    if (trimmed.includes('vimeo.com/')) {
      const id = trimmed.split('vimeo.com/')[1]?.split('?')[0];
      return `https://player.vimeo.com/video/${id}?autoplay=1`;
    }

    return trimmed;
  }

  getCampanhaByID(id: string) {
    this.campanhaService.show(id).subscribe({
      next: (res) => {
        this.campanhaData = res.data;
        const fotoAnexo = this.campanhaData.anexoCampanha?.find(
          (a: any) => a?.tipoAnexoCampanha?.tipo === 'Imagem',
        );
        const DocAnexo = this.campanhaData.anexoCampanha?.find(
          (a: any) => a?.tipoAnexoCampanha?.tipo === 'Apresentação',
        );
        const videoAnexo = this.campanhaData.anexoCampanha?.find(
          (a: any) => a?.tipoAnexoCampanha?.tipo === 'Video',
        );
        const rawVideo = videoAnexo?.anexo?.url;
        this.linkVideo = rawVideo ? this.formatExternalUrl(rawVideo) : undefined;
        this.getComissaoCampanha(this.campanhaData?.tipoFinanciamentoENUM);
        this.getTaxaServico(this.campanhaData?.tipoFinanciamentoENUM);
        if (DocAnexo?.anexo?.id) this.getDocsCampanha(DocAnexo.anexo.id);
        if (fotoAnexo?.anexo?.id) this.getPhotoCampanha(fotoAnexo.anexo.id);
        if (videoAnexo?.anexo?.id) this.getVideoCampanha(videoAnexo.anexo.id);
      },
      error: (err) => {
        console.error(err);
      },
    });
  }

  isCampanhaRecompensa(): boolean {
    return (
      Number(this.campanhaData?.tipoFinanciamentoENUM) === 3 ||
      String(this.campanhaData?.tipoFinanciamento).toLowerCase() === 'recompensa' ||
      (Array.isArray(this.campanhaData?.recompensa) && this.campanhaData.recompensa.length > 0)
    );
  }

  getSomaRecompensas(): number {
    if (!Array.isArray(this.campanhaData?.recompensa)) return 0;
    return this.campanhaData.recompensa.reduce((acc: number, r: any) => {
      const val = Number(r.valor) || 0;
      const qtd = Number(r.quantidade) || 1;
      return acc + val * qtd;
    }, 0);
  }

  getAllTipoFinanciamento() {
    this.enumService.getAllTipoFinanciamento().subscribe((result) => {
      this.tipoFinanciamento = Object.entries(result.data).map(
        ([key, value]) => ({
          id: Number(key),
          label: value,
        }),
      );
      this.setCheck();
    });
  }

  getVideoCampanha(id: number) {
    if (!id) return;
    this.anexoFicheiroService.getAnexo(id).subscribe({
      next: (blob: Blob) => {
        const videoBlob = blob.type
          ? blob
          : new Blob([blob], { type: 'video/mp4' });

        this.vidPreview = this.sanitizer.bypassSecurityTrustResourceUrl(
          URL.createObjectURL(videoBlob),
        ) as any;

        this.VidInfo = {
          nome: `Video_${id}.mp4`,
          tamanho: `${(videoBlob.size / 1024).toFixed(2)} KB`,
          tipo: 'video/mp4',
        };
      },
      error: (err) => console.error(err),
    });
  }

  getPhotoCampanha(id: any) {
    if (!id) return;
    this.anexoFicheiroService.getAnexo(id).subscribe({
      next: (fotoRes: any) => {
        const originalBlob =
          fotoRes instanceof Blob ? fotoRes : new Blob([fotoRes]);

        const imageBlob = originalBlob.type
          ? originalBlob
          : new Blob([originalBlob], { type: 'image/jpeg' });

        const objectUrl = URL.createObjectURL(imageBlob);
        this.imgRawUrl = objectUrl;

        this.imgPreview = this.sanitizer.bypassSecurityTrustUrl(
          objectUrl,
        ) as any;

        this.imgInfo = {
          nome: `Imagem_${id}.jpg`,
          tamanho: `${(imageBlob.size / 1024).toFixed(2)} KB`,
          // tipo: imageBlob.type
          tipo: 'image/jpeg',
        };
      },
      error: (err) => console.error(err),
    });
  }

  getDocsCampanha(id: any) {
    if (!id) return;
    this.anexoFicheiroService.getAnexo(id).subscribe({
      next: (originalBlob: any) => {
        const pdfBlob = originalBlob.type
          ? originalBlob
          : new Blob([originalBlob], { type: 'application/pdf' });

        const objectUrl = URL.createObjectURL(pdfBlob);
        this.docRawUrl = objectUrl;

        this.docPreview =
          this.sanitizer.bypassSecurityTrustResourceUrl(objectUrl);

        this.docInfo = {
          nome: `Apresentação_${id}.pdf`,
          tamanho: `${(pdfBlob.size / 1024).toFixed(2)} KB`,
          tipo: pdfBlob.type,
        };
      },
      error: (err) => console.error(err),
    });
  }

  getPagamentosByCampanhaID() {
    const params = {
      CampanhaID: this.campanha().id,
      PageSize: this.pagination.pageSize || 5,
      PageNumber: this.pagination.pageNumber || 1,
    };

    this.apoioService.list(params).subscribe({
      next: (res) => {
        if (res.retorno.codigo === 200) {
          this.pagination = new Pagination().deserialize(res);
          this.pagamentos = res.data;
        } else {
          this.messageService.add({
            severity: 'warn',
            summary: 'Aviso',
            detail: `Falha ao processar pagamentos da campanha`,
          });
        }
      },
      error(err) {
        console.error(err);
      },
    });
  }

  setCheck() {
    if (this.campanha().tipoFinanciamentoENUM) {
      this.selectedTypeFinancy = this.campanha().tipoFinanciamentoENUM;
    }
  }

  closeDetalhe() {
    this.onCloseModal.emit(true);
  }

  expandDetalhe() {
    this.route.navigate(['/admin/campanha-detalhe/', this.campanha().id]);
  }

  showVideo = false;
  showImage = false;
  ShowDoc = false;

  abrirVideo() {
    this.showVideo = true;
  }

  abrirVideoLink(url?: string) {
    if (!url) return;
    const embed = this.getEmbedUrl(url);
    this.embedVideoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(embed);
    this.showVideo = true;
  }

  abrirLinkExterno(url?: string, event?: Event) {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    const finalUrl = this.formatExternalUrl(url);
    if (finalUrl) {
      window.open(finalUrl, '_blank', 'noopener,noreferrer');
    }
  }

  descarregarFicheiro(url?: string, nomePadrao: string = 'ficheiro', event?: Event) {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    if (!url) return;
    const link = document.createElement('a');
    link.href = url;
    link.download = nomePadrao;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  abrirNovaAba(url?: string, event?: Event) {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    if (!url) return;
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  abrirImagem() {
    this.showImage = true;
  }

  abrirDoc() {
    this.ShowDoc = true;
  }

  closeDoc() {
    if (this.docRawUrl) {
      URL.revokeObjectURL(this.docRawUrl);
      this.docRawUrl = undefined;
    }
    this.docPreview = null as any;
  }

  getSeverityPayment(
    state: string,
  ):
    | 'success'
    | 'info'
    | 'warn'
    | 'danger'
    | 'secondary'
    | 'contrast'
    | null
    | undefined {
    switch (state) {
      case 'Pendente':
        return 'secondary';
      case 'Confirmado':
        return 'success';
      case 'Cancelado':
        return 'warn';
      case 'Retornado':
        return 'info';
      default:
        return 'secondary';
    }
  }

  onPagePayment(event: any) {
    this.pagination.pageNumber = event.page + 1;
    this.pagination.pageSize = event.rows;
    this.getPagamentosByCampanhaID();
  }

  getComissao(valor: number) {
    const comissao =
      (this.campanhaData?.valorArrecado * this.ComissaoCampanha) / 100;
    return comissao;
  }

  getComissaoCampanha(tipoFinanciamento: any) {
    this.configuracoesService.getComissaoCampanha(tipoFinanciamento).subscribe({
      next: (value: any) => {
        this.ComissaoCampanha = value;
      },
    });
  }

  getTaxaServico(tipoFinanciamento: any) {
    this.configuracoesService.getTaxaServico(tipoFinanciamento).subscribe({
      next: (value: any) => {
        this.taxaServico = value;
      },
    });
  }

  getValorOriginal(
    valorFinal: number | undefined,
    taxa: number | undefined,
  ): number {
    if (!valorFinal || !taxa) return 0;

    const taxaDecimal = taxa / 100; // 3.2 → 0.032
    return valorFinal / (1 + taxaDecimal);
  }
}
